/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
import Delete from 'material/embeds/embed/edit/delete/delete_container';
// emoji mart picker (https://github.com/missive/emoji-mart)
import 'emoji-mart/css/emoji-mart.css';
import { Picker } from 'emoji-mart';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/embed/shared/answer/emoji/emoji_styles';



/* ========== ~~~~~~~~~~ EMBED : ANSWER EMOJI : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class AnswerEmoji extends Component {
    constructor(props) {
        super(props);
        this.state = { selected: false };
    }
    componentWillMount() {
        // Emoji answer is always valid because there is always a default selected.
        // We still need to communicate the validation status back to the store since answers gets validated individually
        this.props.updateOptionProperty(this.props.contentId, this.props.optionId, 'isValid', true);
    }
    handleSelect = (e) => {
        document.addEventListener('mousedown', this.handleOutsideClick, false);
        this.setState({ selected: this.state.selected ? false : true });
    };
    emojiSelected = (emoji) => {
        if (!((emoji === undefined) || (emoji === null) || (emoji === ''))) {
            this.props.updateOptionProperty(this.props.contentId, this.props.optionId, 'emoji', emoji.native);
        }
        this.setState({ selected: false });
        document.removeEventListener('mousedown', this.handleOutsideClick, false);
    };
    handleOutsideClick = (e) => {
        // ignore clicks on the component itself
        if (this.node.contains(e.target)) { return; }
        this.emojiSelected();
    };
    render() {
        return(
            <div className={`emoji ${this.props.classes.emoji}`}>
                <span className={`graphic selected-${this.state.selected}`} ref={node => {this.node=node;}}>
                    <span className={`emoji`} onClick={this.handleSelect}>{this.props.currentAnswer.emoji}</span>
                    <Delete contentId={this.props.contentId} optionId={this.props.optionId} position={`top right`} />
                    <Picker onSelect={this.emojiSelected} />
                </span>
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(AnswerEmoji);
